// Offer Modal functionality
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded');
    var offerModal = document.getElementById('offerModal');
    console.log('Offer Modal Element:', offerModal);
    if (!offerModal) {
      console.error('Offer Modal not found in the DOM');
      return;
    }
  
    var addToCartBtn = document.querySelector('.add-to-cart');
    console.log('Add to Cart Button:', addToCartBtn);
    var modalType = offerModal.getAttribute('data-modal-type') || 'standard';
    var collectionsToCheck = JSON.parse(offerModal.getAttribute('data-collections-to-check') || '[]');
    var productCollections = JSON.parse(offerModal.getAttribute('data-product-collections') || '[]');
  
    console.log('Modal Type:', modalType);
    console.log('Collections to Check:', collectionsToCheck);
    console.log('Product Collections:', productCollections);
  
    let previousCartItemCount = 0;
  
    function showModal() {
      console.log('Attempting to show modal');
      offerModal.style.display = 'block';
      setTimeout(() => {
        offerModal.classList.add('active');
        setTimeout(() => {
          offerModal.classList.add('shake');
          setTimeout(() => {
            offerModal.classList.remove('shake');
          }, 2000); // Remove shake class after animation completes
        }, 500); // Start shake after slide-in animation
      }, 10);
      console.log('Modal displayed');
    }
  
    function hideModal() {
      console.log('Hiding modal');
      offerModal.classList.remove('active');
      setTimeout(() => {
        offerModal.style.display = 'none';
        offerModal.classList.remove('shake');
      }, 500);
    }
  
    function isProductInCollectionsToCheck() {
      console.log('Checking if product is in collections to check');
      var result = productCollections.some(collection => collectionsToCheck.includes(collection));
      console.log('Is product in collections to check:', result);
      return result;
    }
  
    function checkCartAndShowModal() {
      console.log('checkCartAndShowModal function called');
      console.log('Checking cart and potentially showing modal');
  
      if (!isProductInCollectionsToCheck()) {
        console.log('Product not in collections to check, not showing modal');
        return;
      }
  
      console.log('Product is in collections to check');
  
      if (modalType === 'standard') {
        console.log('Modal type is standard, showing modal');
        showModal();
      } else if (modalType === 'buyxgety') {
        console.log('Modal type is buyxgety, checking cart');
        
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('Cart fetched successfully');
            console.log('Cart items:', cart.items);
            
            let currentCartItemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
            console.log('Current total items in cart:', currentCartItemCount);
            console.log('Previous total items in cart:', previousCartItemCount);
            
            if (currentCartItemCount > previousCartItemCount) {
              let showModalFlag = currentCartItemCount % 2 !== 0;
              
              console.log('Cart updated. Show modal flag:', showModalFlag);
              
              if (showModalFlag) {
                console.log('Conditions met, showing modal for buyxgety');
                showModal();
              } else {
                console.log('Not showing modal for buyxgety, conditions not met');
              }
              
              previousCartItemCount = currentCartItemCount;
            } else {
              console.log('Cart not updated or item not added successfully. Not showing modal.');
            }
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
          });
      }
    }
  
    if (addToCartBtn) {
      console.log('Adding click event listener to Add to Cart button');
      addToCartBtn.addEventListener('click', function(event) {
        console.log('Add to Cart button clicked');
        // Wait for a short time to allow the cart to update
        setTimeout(checkCartAndShowModal, 500);
      });
    } else {
      console.error('Add to Cart button not found');
    }
  
    // Initialize previousCartItemCount when the page loads
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        previousCartItemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
        console.log('Initial cart item count:', previousCartItemCount);
      })
      .catch(error => {
        console.error('Error fetching initial cart:', error);
      });
  
    offerModal.querySelector('.close-modal-btn').addEventListener('click', hideModal);
  });
  
  // Log when the script has finished running
  console.log('Offer Modal script fully loaded and executed');